import React from "react";
import { FormattedMessage } from "react-intl";
import { useAuth, useLinks, useModalConfirmation, useQueryData, useToast } from "hooks";
import { WITHDRAW_APPLICATION } from "graphql/mutations";
import { useMutation } from "@apollo/client";
import { GET_PUBLIC_MISSION_ROLE_ELIGIBILITY } from "graphql/queries";
import { Col } from "components/Containers";
import { MISSION_ROLE_STATES, APPLICANT_TYPES } from "constants/index";

export default function usePublicMissionRoleEligibility({ missionRoleId }) {
  const { show } = useModalConfirmation();
  const links = useLinks();
  const { toast } = useToast();
  const { isMember } = useAuth();
  const [withdrawApplication] = useMutation(WITHDRAW_APPLICATION);

  const { loading, data, error } = useQueryData({
    queryName: GET_PUBLIC_MISSION_ROLE_ELIGIBILITY,
    skip: !missionRoleId,
    variables: { missionRoleId },
  });

  const handleWithdrawApplication = async (application, role, newRole) => {
    const userNotSelected = application?.state === APPLICANT_TYPES.unselected;
    const roleClosed = role?.state === MISSION_ROLE_STATES.closed;
    const roleNotAvailable = userNotSelected || roleClosed;

    const response = await show(
      <FormattedMessage
        id={`Missions.Applicants.ApplicantAbandon.${roleNotAvailable ? "Closed" : newRole ? `Change` : ``}PromptTitle`}
      />,
      <Col gap="1rem">
        <span>
          <FormattedMessage
            id={`Missions.Applicants.ApplicantAbandon.${
              roleNotAvailable ? "Closed" : newRole ? `Change` : isMember ? `Member` : ``
            }PromptBody1`}
            values={{
              role: <b>{role?.name}</b>,
            }}
          />
        </span>
        <b>
          <FormattedMessage
            id={`Missions.Applicants.ApplicantAbandon.${
              roleNotAvailable ? "Closed" : newRole ? `Change` : ``
            }PromptBody2`}
          />
        </b>
      </Col>,
      {
        primaryButtonMessageId: "Missions.Applicants.ApplicantAbandon.Button.Cta",
      }
    );

    if (response) {
      withdrawApplication({
        variables: {
          input: {
            id: application?.id,
            newRoleId: newRole?.id,
          },
        },
        onCompleted: () => {
          if (!isMember) {
            window.location = links.candidate_home;
          }

          toast.success(<FormattedMessage id="Missions.Applicants.ApplicantAbandon.Success" />);
        },
        onError: () => {
          toast.error(<FormattedMessage id="Missions.Applicants.ApplicantAbandon.Error" />);
        },
      });
    }
  };

  return {
    loading,
    data: data?.publicMissionRoleEligibilityFetch,
    error,
    handleWithdrawApplication,
  };
}
